import * as React from 'react';
import Paper from '@material-ui/core/Paper';
import { createStyles, Theme, WithStyles, withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import CustomerViewContents from './customer_view_contents';
import { ReactComponent as Vectors } from '../../images/Vectors.svg';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      height: '100%',
    },
    flexOne: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
    },
    paper: {
      alignSelf: 'center',
      padding: theme.spacing(5),
      borderRadius: theme.spacing(1),
      marginTop: theme.spacing(5),
      marginLeft: theme.spacing(5),
      marginRight: theme.spacing(5),
      maxWidth: '1000px',
      width: `calc(100% - ${theme.spacing(20)}px)`,
    },
    linkRow: {
      margin: theme.spacing(5),
    },
    backgroundDivStyle: {
      backgroundColor: theme.palette.primary.main,
      height: '350px',
      right: '0px',
      left: '0px',
      position: 'absolute',
      zIndex: -1,
    },
    vectors: {
      position: 'absolute',
      left: '0px',
      right: '0px',
      bottom: '0px',
    },
  });

const CustomerViewRateSheetPage = (props: WithStyles<typeof styles>) => {
  const { classes, ...otherProps } = props;
  return (
    <Grid container spacing={0} className={classes.root}>
      <div className={classes.backgroundDivStyle}>
        <Vectors className={classes.vectors} />
      </div>
      <Grid item xs={12} className={classes.flexOne}>
        <Grid container justifyContent="center" className={classes.flexOne}>
          <Paper className={`${classes.paper} ${classes.flexOne}`}>
            <CustomerViewContents {...otherProps} />
          </Paper>
        </Grid>
      </Grid>
      <Grid item xs={12} className={classes.linkRow}>
        <Grid container justifyContent="center">
          <a rel="noopener noreferrer" target="_blank" href="https://www.freightlegend.com/">
            Powered by FreightLegend
          </a>
        </Grid>
      </Grid>
    </Grid>
  );
};
export default withStyles(styles, { withTheme: true })(CustomerViewRateSheetPage);
